"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Settings02 = function Settings02(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9.3951 19.3711.5845 1.3145A2.212 2.212 0 0 0 12.0018 22a2.212 2.212 0 0 0 2.0222-1.3144l.5844-1.3145a2.426 2.426 0 0 1 1-1.1111 2.433 2.433 0 0 1 1.47-.3122l1.43.1522a2.212 2.212 0 0 0 2.1489-1.0944 2.21 2.21 0 0 0 .2938-1.2227 2.21 2.21 0 0 0-.4204-1.1851l-.8467-1.1634A2.43 2.43 0 0 1 19.224 12a2.43 2.43 0 0 1 .4644-1.4289l.8467-1.1633A2.211 2.211 0 0 0 20.6618 7a2.212 2.212 0 0 0-2.1489-1.0944l-1.43.1522a2.433 2.433 0 0 1-1.47-.3122 2.426 2.426 0 0 1-1-1.1167l-.5889-1.3145A2.212 2.212 0 0 0 12.0018 2a2.212 2.212 0 0 0-2.0222 1.3144L9.395 4.629a2.426 2.426 0 0 1-1 1.1167 2.433 2.433 0 0 1-1.47.3122l-1.4344-.1522A2.212 2.212 0 0 0 3.3417 7a2.211 2.211 0 0 0 .1267 2.4078l.8467 1.1633c.302.4153.4645.9155.4645 1.4289a2.43 2.43 0 0 1-.4645 1.4289l-.8467 1.1633A2.211 2.211 0 0 0 3.3418 17a2.214 2.214 0 0 0 2.1489 1.0944l1.43-.1522a2.434 2.434 0 0 1 1.47.3122 2.426 2.426 0 0 1 1.0044 1.1167"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 15c1.6568 0 3-1.3431 3-3s-1.3432-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    })]
  }));
};
var _default = exports["default"] = Settings02;